import { render, staticRenderFns } from "./order-product-info.vue?vue&type=template&id=126c4e10&scoped=true&"
import script from "./order-product-info.vue?vue&type=script&lang=js&"
export * from "./order-product-info.vue?vue&type=script&lang=js&"
import style0 from "./order-product-info.vue?vue&type=style&index=0&id=126c4e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c4e10",
  null
  
)

export default component.exports